/**
 * Small color swatch used next to a class label — the classification results
 * table, the cost summary rows, and the below-minimum/unclassified special
 * rows all render the same shape, so it's a single shared component rather
 * than a copy defined in each file. Layer and object rows render their own
 * larger, clickable swatch — see ObjectColorPicker.
 *
 * @param {object} props
 * @param {string} props.color - any valid CSS color (hex/rgba)
 */
const ColorDot = ({ color }) => (
	<span
		style={{
			display: 'inline-block',
			width: 10,
			height: 10,
			borderRadius: 2,
			background: color,
			marginRight: 6,
			verticalAlign: 'middle',
		}}
	/>
);

export default ColorDot;
